import './App.css';
import { Routes, Route } from "react-router-dom";
import Footer from "./Components/Partials/Footer"
import Homepage from "./Pages/Homepage"
import Compounds from "./Pages/Compounds"
import Result from "./Pages/Result"
import NotFound from "./Pages/NotFound"
import FoodDatabase from "./Pages/FoodDatabase"
import Angelica from "./Pages/Static/Angelica"
import Savoy from "./Pages/Static/Savoy"
import VirtualTaste from './Pages/VirtualTaste';
import Silver from './Pages/Static/Silver';
import Kiwi from './Pages/Static/Kiwi';
import Allium from './Pages/Static/Allium';
import Organoleptic from './Pages/Organoleptic';
import ThankyouPage from './Pages/ThankyouPage';
function App() { 
  return <>

  <Routes>
    <Route path="/" element={<Homepage />} />
    <Route path="/compounds" element={<Compounds />} />
    <Route path="/result" element={<Result />} />

    <Route path="/foods" element={<FoodDatabase />} />
    <Route path="/virtual-taste" element={<VirtualTaste />} />
    <Route path="/organoleptic" element={<Organoleptic />} />
    <Route path="/thanks" element={<ThankyouPage />} />

    {/**Pagine statiche */}
    <Route path="/details/Angelica" element={<Angelica />} />
    <Route path="/details/Savoy-cabbage" element={<Savoy />} />
    <Route path="/details/Silver-linden" element={<Silver />} />
    <Route path="/details/Kiwi" element={<Kiwi />} />
    <Route path="/details/Allium" element={<Allium />} />

    <Route path="/*" element={<NotFound />}/>
  </Routes>
  <Footer />
  </>;
}

export default App;
